/**
 * 鸟猪 PK 进度：仅 Cookie 持久化，不走后端。
 */
const COOKIE_KEY = 'angry_birds_pk_v1'
const MAX_AGE_SEC = 365 * 24 * 60 * 60

function readRawCookie(name) {
  const parts = String(document.cookie || '').split(';')
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i].trim()
    if (p.indexOf(name + '=') === 0) {
      return decodeURIComponent(p.substring(name.length + 1))
    }
  }
  return ''
}

function writeRawCookie(name, value, maxAge) {
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : ''
  document.cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    '; path=/' +
    '; max-age=' +
    Math.max(0, maxAge | 0) +
    '; SameSite=Lax' +
    secure
}

export function loadBirdGameState() {
  const fallback = { bird: 0, pig: 0, paused: false }
  try {
    const raw = readRawCookie(COOKIE_KEY)
    if (!raw) return { ...fallback }
    const data = JSON.parse(raw)
    return {
      bird: Math.max(0, parseInt(data.bird, 10) || 0),
      pig: Math.max(0, parseInt(data.pig, 10) || 0),
      paused: !!data.paused
    }
  } catch (e) {
    return { ...fallback }
  }
}

export function saveBirdGameState(state) {
  const payload = {
    bird: Math.max(0, parseInt(state && state.bird, 10) || 0),
    pig: Math.max(0, parseInt(state && state.pig, 10) || 0),
    paused: !!(state && state.paused),
    updatedAt: Date.now()
  }
  writeRawCookie(COOKIE_KEY, JSON.stringify(payload), MAX_AGE_SEC)
}

export function clearBirdGameState() {
  writeRawCookie(COOKIE_KEY, '', 0)
}
